import React from 'react';
import { Layout, Space } from 'antd';
import { GithubOutlined, WechatOutlined, MailOutlined } from '@ant-design/icons';
import './Footer.css';

const { Footer: AntFooter } = Layout;

const AppFooter = () => {
  return (
    <AntFooter className="app-footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>关于我们</h3>
          <p>专业的自动发卡平台，安全快捷的虚拟商品交易服务</p>
        </div>
        
        <div className="footer-section">
          <h3>联系方式</h3>
          <Space direction="vertical">
            <div><WechatOutlined /> 微信客服：请联系管理员</div>
            <div><MailOutlined /> 邮箱：support@example.com</div>
          </Space>
        </div>
        
        <div className="footer-section">
          <h3>关注我们</h3>
          <Space size="large">
            <GithubOutlined style={{ fontSize: 24 }} />
            <WechatOutlined style={{ fontSize: 24 }} />
          </Space>
        </div>
      </div>
      
      <div className="footer-bottom">
        <p>© 2025 发卡网. All rights reserved.</p>
      </div>
    </AntFooter>
  );
};

export default AppFooter;
